import React from 'react';
import { motion } from 'framer-motion';
import { FaTelegram } from 'react-icons/fa';

export const SupportButton = () => {
  const TELEGRAM_LINK = 'https://t.me/Nitrologs9';

  const handleClick = () => {
    window.open(TELEGRAM_LINK, '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.button
      onClick={handleClick}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 0.3, type: 'spring', stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-8 right-6 z-40 p-4 bg-linear-to-r from-blue-400 to-blue-600 text-white rounded-full shadow-2xl hover:shadow-blue-500/50 transition-all duration-300"
      title="Contact Support on Telegram"
    >
      <FaTelegram className="w-6 h-6" />
    </motion.button>
  );
};
